import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { CheckboxBodyCell, RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { useOrderListContext } from './Context'
import { DataListRow } from './DataListRow'

export const ListRow = (props: BodyRowConfig<EntityWithSelection<Order>>) => {
  const { _id, _selected } = props
  const { orderListWithSelection } = useOrderListContext()
  const { toggleSelectBy } = orderListWithSelection

  return (
    <>
      <RowNumberBodyCell {...props} />
      <CheckboxBodyCell
        checked={_selected}
        onChange={() => {
          toggleSelectBy((item) => item._id === _id)
        }}
      />

      <DataListRow {...props} />
    </>
  )
}
